import {
  initialize,
  getAutoDeliveryMarketConfiguration
} from '@fe-sdk/cbx-orders'
import {
  FetchAutoDeliveryConfigDataParams,
  AutoDeliveryConfigData,
  AutoDeliveryConfigDataOrResponse
} from './types'
import MockAutoDeliveryConfig from './api-mock-auto-delivery-config.mock'
import { SDK_INITIALIZE_CONFIG } from '../sdk-config'

initialize(SDK_INITIALIZE_CONFIG)

const getAutoDeliveryConfigFromData = <
  T = AutoDeliveryConfigData & { status?: number }
>(
  data: AutoDeliveryConfigDataOrResponse<T> | undefined
): T | undefined => {
  if (!data) {
    return undefined
  }

  if (typeof data === 'object' && 'data' in data && data.data) {
    const configData = 'data' in data.data ? data.data.data : data.data
    return {
      ...(configData as { data: object }),
      status: data.status
    } as T
  }

  return data as T
}

const fetchAutoDeliveryConfig = async <T = AutoDeliveryConfigData>({
  config,
  token,
  consumerId = 'anonymous',
  isMock = false
}: FetchAutoDeliveryConfigDataParams): Promise<T | undefined> => {
  if (isMock) {
    const mockSdkResponse = {
      data: {
        data: MockAutoDeliveryConfig
      },
      status: 200
    }
    return getAutoDeliveryConfigFromData<T>(
      mockSdkResponse as AutoDeliveryConfigDataOrResponse<T>
    )
  }

  const sdkResponse = await getAutoDeliveryMarketConfiguration({
    baseURL: config?.cbxUrl ?? '',
    brand: config?.brand || 'IQOS',
    channel: config?.xChannel || 'WEBSITE',
    countryCode: config?.market?.toUpperCase() ?? '',
    targetGroup: config?.targetGroup || 'B2C',
    token: token ?? '',
    consumerId: consumerId ?? ''
  })

  return getAutoDeliveryConfigFromData<T>(
    sdkResponse as AutoDeliveryConfigDataOrResponse<T>
  )
}

export default {
  fetchAutoDeliveryConfig
}
